/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Type of reward to payout.
 * @export
 * @enum {string}
 */
export enum RewardType {
    FUEL = 'FUEL',
    NFT = 'NFT',
    PROMO = 'PROMO',
    PROMOTOKEN = 'PROMO_TOKEN',
    MERCH = 'MERCH',
    GIFTCARD = 'GIFT_CARD',
    XP = 'XP',
    XPMULTIPLIER = 'XP_MULTIPLIER',
    LEADERBOARDPOINTS = 'LEADERBOARD_POINTS',
    OTHER = 'OTHER'
}

export function RewardTypeFromJSON(json: any): RewardType {
    return RewardTypeFromJSONTyped(json, false);
}

export function RewardTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardType {
    return json as RewardType;
}

export function RewardTypeToJSON(value?: RewardType | null): any {
    return value as any;
}

